import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { clearAuth, setAccessToken } from '@/config/api/authStore'
import { resetWorkspaceSession } from '@/services/workspaces/resetWorkspaceSession'

// Persists the session (user + tokens) to localStorage so a reload stays signed
// in. rehydrateAuthSession() re-wires the axios token + refresh handler at boot.
export const useAuthSessionStore = create(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      loginType: null,

      setSession: ({ user, accessToken, refreshToken, loginType }) => {
        setAccessToken(accessToken)
        set({ user, accessToken, refreshToken: refreshToken ?? null, loginType: loginType ?? null })
      },

      clearSession: () => {
        clearAuth()
        resetWorkspaceSession()
        set({ user: null, accessToken: null, refreshToken: null, loginType: null })
      },
    }),
    {
      name: 'do-sense-auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        user: s.user,
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        loginType: s.loginType,
      }),
    },
  ),
)
